<footer class="main-footer" [class.slim]="layout === 'slim'">
  <div class="footer-header-container">
    <div class="footer-header">
      <img
        src="assets/images/ina-logo.svg"
        alt="INA Logo"
        class="h-12 cursor-pointer"
      />
    </div>
    <!-- <div class="container">
      <div class="footer-column company-info">
        <h3>{{ "FOOTER.COMPANY_INFO" | translate }}</h3>
        <ul>
          <li>
            <a href="#">{{ "FOOTER.ABOUT_US" | translate }}</a>
          </li>
          <li>
            <a href="#">{{ "FOOTER.CAREERS" | translate }}</a>
          </li>
          <li>
            <a href="#">{{ "FOOTER.CONTACT" | translate }}</a>
          </li>
        </ul>
      </div>

      <div class="footer-column legal">
        <h3>{{ "FOOTER.LEGAL" | translate }}</h3>
        <ul>
          <li>
            <a href="#">{{ "FOOTER.PRIVACY_POLICY" | translate }}</a>
          </li>
          <li>
            <a href="#">{{ "FOOTER.TERMS_CONDITIONS" | translate }}</a>
          </li>
        </ul>
      </div>

      <div class="footer-column products">
        <h3>{{ "FOOTER.PRODUCTS" | translate }}</h3>
        <ul>
          <li>
            <a href="#">{{ "FOOTER.FEATURES" | translate }}</a>
          </li>
          <li>
            <a href="#">{{ "FOOTER.PRICING" | translate }}</a>
          </li>
          <li>
            <a href="#">{{ "FOOTER.SUPPORT" | translate }}</a>
          </li>
        </ul>
      </div>

      <div class="footer-column resources">
        <h3>{{ "FOOTER.RESOURCES" | translate }}</h3>
        <ul>
          <li>
            <a href="#">{{ "FOOTER.BLOG" | translate }}</a>
          </li>
          <li>
            <a href="#">{{ "FOOTER.DOCUMENTATION" | translate }}</a>
          </li>
        </ul>
      </div>

      <div class="footer-column get-in-touch">
        <h3>{{ "FOOTER.GET_IN_TOUCH" | translate }}</h3>
        <p>{{ "FOOTER.ADDRESS" | translate }}</p>
        <p>{{ "FOOTER.PHONE" | translate }}</p>
        <p>{{ "FOOTER.EMAIL" | translate }}</p>
      </div>
    </div> -->
  </div>
  <div class="footer-bottom">
    <p>{{ "FOOTER.COPYRIGHT" | translate }}</p>
    <!-- <div class="social-icons">
      <a href="#" target="_blank"><i class="fab fa-facebook-f"></i></a>
      <a href="#" target="_blank"><i class="fab fa-twitter"></i></a>
      <a href="#" target="_blank"><i class="fab fa-instagram"></i></a>
      <a href="#" target="_blank"><i class="fab fa-linkedin-in"></i></a>
    </div> -->
  </div>
</footer>
